import { Box, Card, CardContent, Grid, Skeleton, Stack } from "@mui/material";

function PlanCardSkeleton() {
  return (
    <Card sx={{ height: "100%", minHeight: 200 }}>
      <CardContent>
        <Skeleton variant="text" width="60%" height={28} />
        <Skeleton variant="text" width="40%" height={20} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="50%" height={36} sx={{ mt: 2 }} />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <Skeleton variant="text" width="80%" height={16} />
          <Skeleton variant="text" width="70%" height={16} />
          <Skeleton variant="text" width="75%" height={16} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function BillingPageSkeleton() {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: 3 }).map((_, i) => (
        <Grid item xs={12} md={4} key={i}>
          <PlanCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}
